import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CustomScrollbars from '../CustomScrollbars';

class CroppedCultures extends Component {
	handleRemoveClick = e => {
		e.preventDefault();

		const id = e.target.dataset.id;
		this.props.onRemove(id);
	}

	render () {
		const { list } = this.props;

		return (
			<div>
				<h3 className="text-center">История посевов</h3>
				<CustomScrollbars autoHeight autoHeightMin={50} autoHeightMax={200}>
					<table className="table table-bordered">
						<thead>
							<tr>
								<th>Год</th>
								<th>Культура</th>
								<th>Га</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{
								list.map((el, key) => <tr key={key}>
									<td>{el.year}</td>
									<td>{el.name}</td>
									<td>{el.area}</td>
									<td>
										<button className="btn btn-danger" onClick={this.handleRemoveClick} data-id={el.culture_id}>
											Удалить
										</button>
									</td>
								</tr>)
							}
						</tbody>
					</table>
				</CustomScrollbars>
			</div>
		);
	}
}

CroppedCultures.propTypes = {
	list: PropTypes.array,
	onRemove: PropTypes.func.isRequired
};

export default CroppedCultures;



// WEBPACK FOOTER //
// ./components/ClientForm/CroppedCultures.js